import React from 'react'
import Modal from '../components/Modal'

const withErrorHandler = (WrappedComponent, handleClose) => {
  return (
    <Modal handleClose={handleClose}>
      <WrappedComponent />
    </Modal>
  )
}

export default withErrorHandler
